const InViewFactory = require('kudago-in-view');
const ajax = require('component-ajax');
const throttle = require('lodash/throttle');
const emit = require('emmy/emit');
const sample = require('lodash/sample');
const q = require('queried');
const domify = require('domify');
const AdvertButton = require('./advert-button');

const { undomify } = require('./utils');

class SpecialWidget {
  constructor({ el }) {
    this.el = el;
    SpecialWidget.instances.push(this);
    this.inView = InViewFactory();
    this.inView.offset(-100);

    // we have to declare this method on instance
    // to unbind it later
    this.handleScroll = throttle(() => {
      if (this.isVisible()) {
        SpecialWidget.fetch();
      }
    }, 400);

    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  unbind() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  isVisible() {
    return this.inView.is(this.el);
  }

  render(data) {
    const content = data[this.getTypeOfWidget()];

    if (!content || !content.trim()) {
      return;
    }

    this.el.innerHTML = content;
    this.el.classList.remove('preloading');

    this.showWidget();
  }

  showWidget() {
    const hiddenParent = this.el.closest('[hidden]');
    if (hiddenParent) {
      hiddenParent.removeAttribute('hidden');
    }
  }

  getTypeOfWidget() {
    if (this.el.className.includes('special-soon-widget') || this.el.className.includes('special-soon-mockup-widget')) {
      return 'soon';
    }

    return 'recommendations';
  }

  static preprocessFetchedData(data) {
    const { recommendations } = data;

    if (!recommendations) {
      return data;
    }

    const recommendationsFragment = domify(recommendations);

    const groupClassName = kudago.mobile ? '.swiper-slide' : '.special-widget-group';
    const itemClassName = kudago.mobile ? '.fs-item' : '.special-widget-item';

    q.all(groupClassName, recommendationsFragment).map((groupElem) => {
      const groupItems = q.all(itemClassName, groupElem);
      return sample(groupItems).removeAttribute('hidden');
    });

    return {
      ...data, recommendations: undomify(recommendationsFragment),
    };
  }

  static fetch() {
    // prevent fetching of data twice
    // that also makes the widget render twice
    if (SpecialWidget.requestInProcess) {
      return;
    }
    const mixes = kudago.itemPageNames.length ? kudago.itemPageNames : kudago.page;
    const cachedData = SpecialWidget.cache[mixes];

    let isMockupRender = false;
    let eotdId = null;
    let featuredItemId = null;

    const eotwWidgetContainer = q('.eotw-container');
    const singleWidgetsContainer = q('.singleWidgets');

    if (eotwWidgetContainer && eotwWidgetContainer.dataset.eotd_id) {
      isMockupRender = true;
      eotdId = eotwWidgetContainer.dataset.eotd_id;
    }
    if (singleWidgetsContainer && singleWidgetsContainer.dataset.featured_item_id) {
      isMockupRender = true;
      featuredItemId = singleWidgetsContainer.dataset.featured_item_id;
    }

    const renderWidgets = (data) => {
      SpecialWidget.instances.forEach((item) => {
        item.render(data);
      });
      const AdButton = new AdvertButton();
      AdButton.update();
    };

    if (cachedData) {
      renderWidgets(cachedData);

      SpecialWidget.instances.forEach((item) => {
        item.unbind();
      });
    } else {
      const data = {
        force_flavour: kudago.flavour,
        location: kudago.location,
      };

      if (isMockupRender && eotdId) {
        data.eotd_id = eotdId;
      }

      if (isMockupRender && featuredItemId) {
        data.featured_item_id = featuredItemId;
      }

      if (kudago.isItemPage && kudago.itemTagSlugs) {
        data.tag_slugs = kudago.itemTagSlugs;
      } else if (kudago.tagSlug) {
        data.tag_slugs = [kudago.tagSlug];
      }

      if (window._metricsConfig.item && window._metricsConfig.item.slug) {
        data.for_item = window._metricsConfig.item.slug;
      }

      if (mixes) {
        data.mixes = mixes;
      }

      SpecialWidget.requestInProcess = true;

      ajax({
        url: '/widgets/special-items/',
        data,
        success: (response) => {
          if (response) {
            const processedResponse = this.preprocessFetchedData(response);
            SpecialWidget.cache[mixes] = processedResponse;
            renderWidgets(processedResponse);
            emit(document, 'special-widgets-loaded');
          }

          SpecialWidget.instances.forEach((item) => {
            item.unbind();
          });

          SpecialWidget.requestInProcess = false;
        },
      });
    }
  }
}

SpecialWidget.requestInProcess = false;
SpecialWidget.instances = [];
SpecialWidget.cache = {};

module.exports = SpecialWidget;
